import DevEnvironment from './environment.dev'
import ProdEnvironment from './environment.prod'

const Environment = process.env.NODE_ENV === 'production' ? ProdEnvironment : DevEnvironment

export default Environment
